import React from 'react';
import {useNavigation} from '@react-navigation/native';

import {Header} from '../../components/Interface/Headers/Header';
import {ScreenTitle} from '../../components/shared/ScreenTitle';
import {useAuth} from '../../context/auth';
import {useGlobal} from '../../context/global';
import {Maintenance} from '../../components/Interface/Maintenance';

import bannerRoleta from '../../assets/images/banners/bannerRoleta.webp';
import bannerConquistas from '../../assets/images/banners/bannerConquistas.webp';
import bannerIndique from '../../assets/images/banners/bannerIndique.webp';
import bannerCheckIn from '../../assets/images/banners/bannerCheckIn.webp';

import {
  Container,
  BannersContainer,
  Row,
  BannerItem,
  BannerLabel,
  BannerTitle,
  BannerImage,
} from './styles';

const benefitsBanners = [
  {
    id: 'indique',
    title: 'Indique e Ganhe',
    image: bannerIndique,
    route: 'ReferAndWin',
  },
  {id: 'roleta', title: 'Gire e Ganhe', image: bannerRoleta, route: 'Roulette'},
  {
    id: 'checkin',
    title: 'Check-in Diário',
    image: bannerCheckIn,
    route: 'Checkin',
  },
  {
    id: 'conquistas',
    title: 'Conquistas',
    image: bannerConquistas,
    route: 'Achievements',
  },
];

export function Beneficios() {
  const navigation = useNavigation();
  const {isLogged, openSign} = useAuth();
  const {disabledFeatures} = useGlobal();
  const isDisabled = (key: string) => disabledFeatures.includes(key);

  function handleOpen(route: string) {
    if (!isLogged) {
      openSign();
      return;
    }

    navigation.navigate(route as never);
  }

  if (isDisabled('beneficios')) {
    return <Maintenance />;
  }

  return (
    <Container>
      <Header icon="chevron-left" />

      <ScreenTitle title="Ganhe mais desconto hoje" />

      <BannersContainer>
        {benefitsBanners
          .filter(banner => !isDisabled(banner.id))
          .map(banner => (
          <Row key={banner.id}>
            <BannerItem
              activeOpacity={0.9}
              onPress={() => handleOpen(banner.route)}>
              <BannerLabel>
                <BannerTitle>{banner.title}</BannerTitle>
              </BannerLabel>
              <BannerImage source={banner.image} resizeMode="cover" />
            </BannerItem>
          </Row>
        ))}
      </BannersContainer>
    </Container>
  );
}
